(() => {
  const slider = document.querySelector("[data-slider]");
  const anchorLinks = Array.from(
    document.querySelectorAll('a[href^="#"]:not([href="#"])')
  );

  anchorLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      const href = link.getAttribute("href");

      if (!href) {
        return;
      }

      const target = document.querySelector(href);

      if (!target) {
        return;
      }

      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  if (!slider) {
    return;
  }

  const slides = Array.from(slider.querySelectorAll("[data-slide]"));
  const triggers = Array.from(slider.querySelectorAll("[data-slide-trigger]"));
  const intervalMs = Number(slider.getAttribute("data-autoplay-interval")) || 5000;
  let currentIndex = slides.findIndex((slide) => slide.classList.contains("is-active"));
  let timerId = null;

  if (currentIndex < 0) {
    currentIndex = 0;
  }

  const syncSlider = (index) => {
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle("is-active", slideIndex === index);
    });

    triggers.forEach((trigger, triggerIndex) => {
      const isActive = triggerIndex === index;
      trigger.classList.toggle("is-active", isActive);
      trigger.setAttribute("aria-selected", String(isActive));
    });

    currentIndex = index;
  };

  const startAutoplay = () => {
    stopAutoplay();
    timerId = window.setInterval(() => {
      const nextIndex = (currentIndex + 1) % slides.length;
      syncSlider(nextIndex);
    }, intervalMs);
  };

  const stopAutoplay = () => {
    if (timerId !== null) {
      window.clearInterval(timerId);
      timerId = null;
    }
  };

  triggers.forEach((trigger, index) => {
    trigger.addEventListener("click", () => {
      syncSlider(index);
      startAutoplay();
    });
  });

  slider.addEventListener("mouseenter", stopAutoplay);
  slider.addEventListener("mouseleave", startAutoplay);
  slider.addEventListener("focusin", stopAutoplay);
  slider.addEventListener("focusout", startAutoplay);

  syncSlider(currentIndex);
  startAutoplay();
})();
